// components/modals/TermsModal.jsx
import React, { useEffect } from "react";
import ReactDOM from "react-dom";

export default function TermsModal({
  open,
  title = "Terms & Conditions",
  onAgree,
  onClose,
  children,
}) {
  // Close on ESC
  useEffect(() => {
    if (!open) return;
    const handler = (e) => e.key === "Escape" && onClose?.();
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [open, onClose]);

  if (!open) return null;

  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="terms-title"
        className="bg-white w-[min(92vw,800px)] max-h-[85vh] rounded-xl shadow-xl overflow-hidden"
      >
        {/* Header */}
        <div className="px-5 py-4 border-b flex items-center justify-between">
          <h3 id="terms-title" className="text-lg font-semibold">
            {title}
          </h3>
          <button
            className="text-gray-500 hover:text-gray-700"
            onClick={onClose}
            aria-label="Close"
          >
            ✕
          </button>
        </div>

        {/* Body */}
        <div className="p-5 overflow-y-auto space-y-4 max-h-[60vh] flex items-center justify-center text-center">
          <p className="text-gray-600">
            Terms and conditions will be added here.
          </p>
        </div>

        {/* Footer */}
        <div className="px-5 py-4 border-t flex items-center justify-end gap-3">
          <button
            className="px-4 py-2 rounded-md border border-gray-300 hover:bg-gray-50"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 rounded-md bg-green-600 text-white hover:bg-green-700"
            onClick={onAgree}
          >
            Agree & Close
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
